var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentationScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Presentation Screen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.0363 12.039C87.0663 10.389 85.7463 9.00899 84.0963 9.00899H6.00629C4.35629 8.97899 2.97629 10.299 2.94629 11.949C2.94629 13.629 4.26629 14.979 5.91629 15.009H84.0063C85.6563 15.009 87.0063 13.689 87.0363 12.039ZM78.0063 72.009C81.3063 72.009 84.0063 69.309 84.0063 66.009V21.009H6.00629V66.009C6.00629 69.309 8.67629 72.009 12.0063 72.009H42.0063V75.819C40.1463 76.869 39.0063 78.849 39.0063 81.009C39.0063 84.309 41.6763 87.009 45.0063 87.009C48.3063 87.009 51.0063 84.309 51.0063 81.009C51.0063 78.849 49.8663 76.869 48.0063 75.819V72.009H78.0063Z",
    fill: "#969696"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationScreen);
export default __webpack_public_path__ + "static/media/PresentationScreen.0102fa0d61d2510bd5cec1a7c9c8b13c.svg";
export { ForwardRef as ReactComponent };